import { AxiosRequestConfig } from 'axios';
import { apiCweb } from '~src/services/api/api-cweb';

export interface GetAttachmentResponse {
  location: string;
  title: string;
}

interface GetAttachmentParams {
  url: string;
}

export const getAttachment = async (
  { url }: GetAttachmentParams,
  axiosConfig?: AxiosRequestConfig
): Promise<GetAttachmentResponse> => {
  const res = await apiCweb.head(url, axiosConfig);

  return {
    location: res.headers.location,
    title: Buffer.from(res.headers?.['file-name'] || '', 'base64').toString(
      'utf-8'
    ),
  };
};
